/** @typedef {'US' | 'GB' | 'CA' | 'ES' | 'AU'} MarketCode */

const EXAMPLE_INVOICE_S3_BASE =
  'https://tiny-invoice.s3.ap-southeast-2.amazonaws.com/public/'

const DEFAULT_EXAMPLE_INVOICE_FILENAME = 'TinyInvoice.app-example.pdf'

/** @type {Record<MarketCode, string>} */
const EXAMPLE_INVOICE_FILENAME_BY_MARKET = {
  US: 'tinyinvoice-us-example.pdf',
  GB: 'tinyinvoice-uk-example.pdf',
  CA: 'tinyinvoice-ca-example.pdf',
  ES: 'tinyinvoice-es-example.pdf',
  AU: 'tinyinvoice-au-example.pdf',
}

/**
 * @param {MarketCode | null | undefined} marketCode
 * @returns {string}
 */
export function getExampleInvoicePdfUrl(marketCode) {
  const filename =
    marketCode && EXAMPLE_INVOICE_FILENAME_BY_MARKET[marketCode]
      ? EXAMPLE_INVOICE_FILENAME_BY_MARKET[marketCode]
      : DEFAULT_EXAMPLE_INVOICE_FILENAME
  return `${EXAMPLE_INVOICE_S3_BASE}${filename}`
}

export const DEFAULT_EXAMPLE_INVOICE_PDF_URL = getExampleInvoicePdfUrl(null)
